import { format, parseISO } from 'date-fns'
import { tr } from 'date-fns/locale'
import type { KpiFormat } from './types'

export const SERIES = ['var(--series-1)', 'var(--series-2)', 'var(--series-3)'] as const

export const TOOLTIP_STYLE = { background: 'var(--popover)', border: '1px solid var(--border)', borderRadius: 10, fontSize: 12, color: 'var(--popover-foreground)', boxShadow: 'var(--card-shadow)' }
export const AXIS_TICK = { fontSize: 11, fill: 'var(--muted-foreground)' }
export const GRID_STROKE = 'var(--border)'

export const monthShort = (m: string) => format(parseISO(`${m}-01`), 'MMM yy', { locale: tr })
export const monthLong = (m: string) => format(parseISO(`${m}-01`), 'LLLL yyyy', { locale: tr })

const tl = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 })
const compact = new Intl.NumberFormat('tr-TR', { notation: 'compact', maximumFractionDigits: 1 })

export function fmtValue(v: number, f: KpiFormat) {
  switch (f) {
    case 'money':
      return tl.format(v)
    case 'pct':
      return `%${v.toLocaleString('tr-TR', { maximumFractionDigits: 1 })}`
    case 'days':
      return `${v.toLocaleString('tr-TR')} gün`
    case 'hours':
      return `${v.toLocaleString('tr-TR')} sa`
    default:
      return v.toLocaleString('tr-TR', { maximumFractionDigits: 1 })
  }
}

export const axisValue = (f: KpiFormat) => (v: number) => (f === 'money' ? `₺${compact.format(v)}` : f === 'pct' ? `%${v}` : compact.format(v))

export const legendOf = (labels: string[]) => labels.map((label, i) => ({ label, color: SERIES[i]! }))
